import React, { useMemo } from 'react'
import Divider from 'LuxKit/Divider'
import MerchandiseMegaMenuContainer from './components/MerchandiseMegaMenuContainer'
import MerchandiseMegaMenuPanel from './components/MerchandiseMegaMenuPanel'
import MerchandiseMegaMenuCategoryList from './components/MerchandiseMegaMenuCategoryList'
import MerchandiseMegaMenuSubcategoryList from './components/MerchandiseMegaMenuSubcategoryList'
import MerchandiseMegaMenuFeaturedBrands from './components/MerchandiseMegaMenuFeaturedBrands'
import { MIN_SUBCATEGORIES } from '../merchandiseUtils'
import useMerchandiseBrandsList from 'hooks/Merchandise/useMerchandiseBrandsList'

interface Props {
  categories: Array<App.MerchandiseCategory>
  hoveredCategoryId?: string
  onCategoryHover: (categoryId: string) => void
  onClose: () => void
}

function MerchandiseCategoryMegaMenu(props: Props) {
  const {
    categories,
    hoveredCategoryId,
    onCategoryHover,
    onClose,
  } = props

  const hoveredCategory = categories.find(cat => cat.id === hoveredCategoryId)

  const shouldShowSubcategories = useMemo(() => {
    return hoveredCategory && hoveredCategory.childCategoryIds.length >= MIN_SUBCATEGORIES
  }, [hoveredCategory])

  // Fetch brand count for the hovered category
  const brandFilters = useMemo(() => {
    if (hoveredCategoryId) {
      return {
        categories: [hoveredCategoryId],
        sortBy: 'top' as const,
        limit: 12,
      }
    }
    return undefined
  }, [hoveredCategoryId])

  const [brandIds] = useMerchandiseBrandsList(brandFilters, { disabled: !hoveredCategoryId })
  const hasSufficientBrands = brandIds.length >= 6

  return <MerchandiseMegaMenuContainer>
    <MerchandiseMegaMenuCategoryList
      categories={categories}
      hoveredCategoryId={hoveredCategoryId}
      onCategoryHover={onCategoryHover}
      onClose={onClose}
    />
    {shouldShowSubcategories && (
      <>
        <Divider kind="secondary" direction="vertical" />
        <MerchandiseMegaMenuSubcategoryList
          category={hoveredCategory}
          onClose={onClose}
        />
        {hasSufficientBrands && (
          <>
            <Divider kind="secondary" direction="vertical" />
            <MerchandiseMegaMenuPanel>
              <MerchandiseMegaMenuFeaturedBrands
                categoryId={hoveredCategoryId}
                columns={3}
                onClose={onClose}
              />
            </MerchandiseMegaMenuPanel>
          </>
        )}
      </>
    )}
  </MerchandiseMegaMenuContainer>
}

export default MerchandiseCategoryMegaMenu
